import React from 'react';

const DropdownIcon = (props) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="16" cy="16" r="16" fill="white" {...props} />
    <path
      d="M10 13L16.2857 18.9014L22.5714 13"
      stroke="#2C2543"
      strokeWidth="2"
      strokeLinecap="round"
      {...props}
    />
  </svg>
);

export default DropdownIcon;
